import type { IconData } from '@stacksjs/iconify-core'

export const pl4x3: IconData = {
  "body": "<g fill-rule=\"evenodd\"><path fill=\"#fff\" d=\"M640 480H0V0h640z\"/><path fill=\"#dc143c\" d=\"M640 480H0V240h640z\"/></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default pl4x3
